import React, { lazy } from 'react';
import { useSelector } from 'react-redux';

// /dashboard is shared between two roles:
//   - seller+warehouse (role 5) -> the new MarketOS Overview dashboard
//   - everyone else (the plain Warehouse role) -> the original warehouse dashboard
// Both are lazy-loaded; the app-level <Suspense> in App.js provides the fallback.
const SellerWarehouseDashboard = lazy(() => import('./DashboardContainer.jsx'));
const WarehouseDashboard = lazy(() => import('../dashbaord'));

export default function DashboardSwitch() {
  const role = useSelector((s) => (s.auth && s.auth.currentUser && s.auth.currentUser.role) || {});
  const isSellerPlusWarehouse = role.id === 5 || role.name === 'seller+warehouse';
  return isSellerPlusWarehouse ? <SellerWarehouseDashboard /> : <WarehouseDashboard />;
}
